if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      connectedCallback() {
        // Subscribe to variant change events to update button price
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.updateButtonPrice(event.data.variant);
        });

        // Listen for quantity changes
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        if (quantityInput) {
          quantityInput.addEventListener('change', () => {
            this.handleQuantityChange();
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      updateButtonPrice(variant) {
        const priceSpan = this.submitButton.querySelector('.js-product-price');
        if (!priceSpan || !variant) return;

        // Helper function to format money
        const formatMoney = (price) => {
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(price, window.money_format || '{{amount}}');
          }
          // Fallback formatting
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: window.shop_currency || 'USD',
            minimumFractionDigits: 2
          }).format(price / 100);
        };

        // Update current price
        const currentPriceElement = priceSpan.querySelector('.price__amount .money');
        if (currentPriceElement && variant.price) {
          currentPriceElement.textContent = formatMoney(variant.price);
        }

        // Handle compare at price and discount
        const compareAtPriceElement = priceSpan.querySelector('.price__amount.snize-discounted-price');
        const saleTagElement = priceSpan.querySelector('.sale_tag');

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          // Show compare at price and sale tag
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = '';
            const compareAtMoney = compareAtPriceElement.querySelector('.money');
            if (compareAtMoney) {
              compareAtMoney.textContent = formatMoney(variant.compare_at_price);
            }
          }
          if (saleTagElement) {
            const discountPercentage = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            saleTagElement.textContent = `${discountPercentage}% OFF`;
            saleTagElement.style.display = '';
          }
        } else {
          // Hide compare at price and sale tag
          if (compareAtPriceElement) {
            compareAtPriceElement.style.display = 'none';
          }
          if (saleTagElement) {
            saleTagElement.style.display = 'none';
          }
        }
      }

      handleQuantityChange() {
        // Get current variant from variant selector (either selects or radios)
        const variantSelect = document.querySelector(`variant-selects[data-section="${this.dataset.sectionId}"]`) ||
                             document.querySelector(`variant-radios[data-section="${this.dataset.sectionId}"]`);
        if (variantSelect && variantSelect.currentVariant) {
          this.updateButtonPrice(variantSelect.currentVariant);
        }
      }
    }
  );
}
